// Components==============
import Button from 'components/UI/Button/Button';
import Shade from 'components/UI/Shade/Shade';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext } from 'react';
import { framerFade } from 'utilities/FramerAnimations';
import { GlobalConfirmContext } from 'utilities/GlobalContext/GlobalConfirm';
import './Confirm.module.scss';
// =========================

export default function Confirm() {
  const {
    confirm,
    setConfirm,
    setConfirmState,
    setTriggerClearConfirmFunction,
  } = useContext(GlobalConfirmContext);

  const translate = useTranslate();

  function handleConfirm() {
    setConfirm('');
    setConfirmState('confirmed');

    setTimeout(() => {
      setConfirmState('idle');
    }, 100);
  }

  function handleDeny() {
    setConfirm('');
    setConfirmState('idle');
    setTriggerClearConfirmFunction((prev) => !prev);
  }

  return (
    <AnimatePresence>
      {confirm && (
        <>
          <motion.div styleName="wrapper" {...framerFade}>
            <h1>{translate('general.terms.be-aware')}</h1>
            <p>{confirm}</p>
            <div styleName="buttons">
              <Button onClick={handleDeny} color="grey">
                {translate('general.terms.cancel')}
              </Button>
              <Button onClick={handleConfirm}>
                {translate('general.terms.confirm')}
              </Button>
            </div>
          </motion.div>
          <div styleName="shade">
            <Shade onClick={handleDeny} />
          </div>
        </>
      )}
    </AnimatePresence>
  );
}
